import React, { useState } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import { renderGlobalModal } from "../../utils/helpers";
import PropTypes from "prop-types";

const Details = (props) => {

  const { userdata } = props;
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = (data) => {
    setLoading(true)
    const request = {};
    request.mentee_id = userdata.mentee_id;
    request.mentor_id = userdata.mentor_id;
    request.review = data.review;
    request.user_role = "Mentor";
    agent
      .post(API.LOAD_CUSTOMER + "/updateReview", request)
      .then((res) => {
        renderGlobalModal({ message: res.data.message });
        setLoading(false);
        props.refreshList();
        props.onHide();
      })
      .catch((err) => {
        setLoading(false)
        renderGlobalModal({ message: "Something went wrong.Please try again." });
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered className="calendar-modal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mentor_detail align-items-center">
            <Col sm={12}>
              <label className="form-label" htmlFor="review">Write a review*</label>
              <Form.Control
                as="textarea"
                className={
                  errors?.review ? "form-control is-invalid" : "form-control"
                }
                name="review"
                defaultValue={userdata.mentor_review}
                aria-invalid={errors?.review ? "true" : "false"}
                {...register("review", { maxLength: 600, required: true })}
              />
              {errors?.review && errors?.review?.type === "required" && (
                <label className="customeValidationText text-left" htmlFor="review">
                  Please enter review
                </label>
              )}
              {errors?.review && errors?.review?.type === "maxLength" && (
                <label className="customeValidationText text-left" htmlFor="review">
                  Review should not more than 600 characters
                </label>
              )}
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div className="form-group mt-3 text-left">
                <button
                  className="btn loginsubmit nextbtn ml-2"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </Col>
          </Row>
        </Form>
        {userdata?.mentor_past_board_roles && userdata?.mentor_past_board_roles.length > 0 && (
          <div className="mt-4">
            <h6 className="mb-3">Mentor's Past Board Roles</h6>
            {userdata?.mentor_past_board_roles?.map((role) => (
              <div key={role.id} className="mb-3 p-2 border-start ps-3" style={{ borderLeftColor: '#007bff', borderLeftWidth: '3px' }}>
                <p className="mb-1"><strong>{role.rep_company_name}</strong></p>
                <p className="mb-1"><em>{role.rep_board_title}</em></p>
                <p className="mb-0 text-muted" style={{ fontSize: '12px' }}>
                  {new Date(role.rep_start_date).toLocaleDateString()} - {new Date(role.rep_end_date).toLocaleDateString()}
                </p>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

Details.propTypes = {
  userdata: PropTypes.shape({
    mentee_id: PropTypes.number.isRequired,
    mentor_id: PropTypes.number.isRequired,
    mentor_review: PropTypes.string,
    mentor_past_board_roles: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        rep_company_name: PropTypes.string,
        rep_board_title: PropTypes.string,
        rep_start_date: PropTypes.string,
        rep_end_date: PropTypes.string,
      })
    ),
  }).isRequired,
  refreshList: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default Details;
